/**
 * Map info window template
 * @param {object} oDatas
 * @param {object} oDatas.photo
 * @param {string} oDatas.staticUrl
 * @param {object} oDatas.offer
 * @param {string} oDatas.offer.name - domain name
 * @param {string} oDatas.offer.url
 * @param {string} oDatas.offer.code - product code
 * @param {object} oDatas.country
 * @param {string[]|string} oDatas.country.name
 * @param {object} oDatas.wording
 * @return {string} - Formatted HTML
 */
const InfoWindowTpl = function (oDatas) {
  const urlPhoto = typeof oDatas.photo !== 'undefined' && typeof oDatas.photo['230x230'] !== 'undefined' && oDatas.photo['230x230'].length ? GLOBAL_SCRIPTS.BASELINK_MEDIA + oDatas.photo['230x230'][0] : oDatas.staticUrl + '/assets/images/default/230x230.jpg',
    offerName = oDatas.offer.name,
    htmlImg = `<img class="lazy gmapInfoWindow-img" src="${urlPhoto}" alt="${offerName}" />`,
    url = typeof oDatas.offer.url !== 'undefined' ? oDatas.offer.url : '#';

  let countryName = oDatas.country.name[GLOBAL_SCRIPTS.LANGUAGE_CODE];

  if (typeof countryName === 'undefined') {
    countryName = oDatas.country.name;
  }

  let accommodationTrackingInfos = {
    clickCode: 'clickOnGmap',
    gaCategory: PAGE_SCRIPTS.page_template,
    gaAction: 'gmapPopinDiscover',
    gaLabel: 'click on image',
    gaValue: 1,
    actionAccommodationsInfos: true,
    accommodationsInfos: [{
      accommodationParkCountryCode: undefined,//country code
      accommodationParkCountryName: countryName,//country name
      accommodationShortSKU: oDatas.offer.code,//product code
      accommodationSKU: undefined,//housing code
      accommodationName: undefined,//housing name
      accommodationRegionCode: undefined,//region code
      accommodationDestinationCode: undefined,// destination code
      accommodationParkCode: oDatas.offer.code,//product code
      accommodationParkName: offerName,//domain name
      accommodationType: undefined,//ex : tree house
      accommodationConfortType: undefined,//comfort level name
      accommodationSeason: 'SUMMER',//season code
      accommodationBrand: typeof oDatas.offer.code !== 'undefined' ? oDatas.offer.code !== 'VN' ? 'CP' : 'VN' : undefined,// BRAND code
      accommodationCapacity: undefined,//housing capacity
      accommodationHasOffer: false,//si offre spéciale
      accommodationAmountTF: undefined,//global price taxe free
      accommodationDiscountAmount: undefined,//reduction
      accommodationGrade: undefined,//trip advisor classement
      accommodationReviewsNumber: undefined,//trip advisor review
      accommodationPosition: undefined,//position in the list displayed
      accommodationHasBookingInfos: false //si les paramètres de la search ont été remplis
    }]
  };
  const ImageAccommodationTrackingInfos = JSON.stringify(accommodationTrackingInfos);

  accommodationTrackingInfos.gaLabel = oDatas.wording.gmap_discover_button;
  const linkAccommodationTrackingInfos = JSON.stringify(accommodationTrackingInfos);

  return `
    <div class="gmapInfoWindow">
      <div class="gmapInfoWindow-imgContainer">
        <a class="gmapInfoWindow-CTA js-Tracking--link"
          href="${url}"
          title="${oDatas.wording.link_title_prefix} ${offerName}"
          data-tracking='${ImageAccommodationTrackingInfos}'>
          ${htmlImg}
        </a>
      </div>
      <div class="gmapInfoWindow-textContainer">
      <p class="gmapInfoWindow-country u-italic">${countryName}</p>
        <p class="gmapInfoWindow-productName">${offerName}</p>
        <a class="js-buttonLoader buttonContainer gmapInfoWindow-CTA js-Tracking--link"
          href="${GLOBAL_SCRIPTS.BASELINK}/${url}"
          title="${oDatas.wording.link_title_prefix} ${offerName}"
          rel="nofollow"
          target="_parent"
          data-tracking='${linkAccommodationTrackingInfos}'>
          <span class="animatedIconContainer">
            <i class="icon icon-arrow_cta icon-arrow--black"></i>
          </span>
          <span class="button button--transparentBlack button--primary button--withIcon">
            ${oDatas.wording.gmap_discover_button}
          </span>
        </a>
      </div>
    </div>`;
};

export {InfoWindowTpl};
